<div class="tag-container">
  <button class="btn btn-secondary btn-small" (click)="clearTags()">{{ 'buttons.clear' | translate }}</button>
  <div *ngFor="let tag of tags" (click)="onInputChanged(tag)">
    <span class="tag-row" [ngClass]="{ 'selected' : selectedTags?.includes(tag.name) }">{{ tag.name }}</span>
  </div>
</div>
